import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-email-confirm-success',
  templateUrl: './email-confirm-success.component.html',
  styleUrls: ['./email-confirm-success.component.scss'],
})
export class EmailConfirmSuccessComponent {
  constructor(private router: Router) {}

  onGoClick() {
    this.router.navigate(['/auth/signin']);
  }
}
